import { useState } from 'react';

import { useFetchWithAuth } from '@/queries/useFetchWithAuth';

import { SearchAutocompleteResponse, SearchType } from '../../types';
import { filterSearchAutocompleteSuggestions, sortAutocompleteByRelevance } from '../utils/searchAutocomplete';

type RequestSuggestionsProps = {
  begintMet: string;
  treindatum?: null | string;
  filterBySearchType?: SearchType[];
  noSuggestions?: number;
};
const useSearchAutocomplete = () => {
  const { fetchWithAuth } = useFetchWithAuth();
  const [suggestions, setSuggestions] = useState<SearchAutocompleteResponse>([]);

  const requestSuggestions = async ({
    begintMet,
    treindatum = null,
    filterBySearchType = [],
    noSuggestions = 10,
  }: RequestSuggestionsProps) => {
    if (begintMet.length <= 1) return;
    let queryParams = `?begintMet=${begintMet}`;
    if (treindatum) queryParams += `&treindatum=${treindatum}`;
    const response = await fetchWithAuth(`/werklijnen/autocomplete${queryParams}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let suggestionsResponse = (response.ok ? ((await response.json()) ?? []) : []).filter(
      filterSearchAutocompleteSuggestions(filterBySearchType),
    );
    suggestionsResponse.sort(sortAutocompleteByRelevance);
    suggestionsResponse = suggestionsResponse.slice(0, noSuggestions);
    setSuggestions(suggestionsResponse);
    return suggestionsResponse;
  };

  const clearSuggestions = () => setSuggestions([]);

  return {
    suggestions,
    requestSuggestions,
    clearSuggestions,
    setSuggestions,
  };
};
export default useSearchAutocomplete;
